export type P4MatrixRow = {
    required_info: string;
    sources: string;
    criteria: string;
    procedures: string;
    possible_evidence: string;
    possible_findings: string;
};

export type P4Question = {
    code: string;
    title: string;
    text: string;
    dimension: "economy" | "efficiency" | "effectiveness";
    linked_risks: string[];
    sub_questions: string[];
    rows: P4MatrixRow[];
};

export type P4FormData = {
    problem_statement: string;
    fundamental_question: string;
    questions: P4Question[];
    glossary: { term: string; definition: string }[];
    consistency_checks: { id: string; text: string; checked: boolean }[];
};

export function defaultP4FormData(): P4FormData {
    return {
        problem_statement: "",
        fundamental_question: "",
        questions: [],
        glossary: [],
        consistency_checks: [
            { id: "d01", text: "All questions specific and linked to objective", checked: false },
            { id: "d02", text: "All required columns present", checked: false },
            { id: "d03", text: "Procedures specific and actionable", checked: false },
            { id: "d04", text: "Sampling documented", checked: false },
            { id: "d05", text: "Possible findings plausible", checked: false },
            { id: "d06", text: "Traceability verified", checked: false },
            { id: "d07", text: "Procedures within scope", checked: false },
            { id: "d08", text: "Benchmarks identified", checked: false },
            { id: "d09", text: "All High/Intolerable risks addressed", checked: false },
        ],
    };
}
